import { Component, OnInit } from '@angular/core';
import { NavigationService } from '../../../core/navigation.service';
import { BreadcrumbExceptionMapping } from '../../../constants';
import { BreadCrumbItem } from '../../../shared/models/breadcrumb-item';

@Component({
  selector: 'lfwms-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent implements OnInit {

  public breadcrumbsArray: {}[]; // = [{ displayName: 'Home', route: '/home', id: 'home' }];
  private index;
  constructor(private navService: NavigationService) {
    navService.getNavigatedMenuIdBroadcast()
      .subscribe((id: any) => {
        /* Subscribe to the navigation service so that whenever
        the menuId is changed refresh the component display */
        this.breadcrumbsArray = this.navService.getCurrentBreadCrumb();
      });
  }

  ngOnInit(): void {
    this.navService.getRemoveBredcrumbStatus().subscribe(ele=>{
      if(ele){
        while (++this.index < this.breadcrumbsArray.length) {
          this.navService.removeLastBreadCrumbItem();
        }
      }
    })
  }

  // Navigates through NavigationService
  public navigateTo(item: BreadCrumbItem, index: number) {
    /* JIRA LFWM-1627 Fix - If we are in primary search page,
    then the navigation from last breadcrumb should not allowed */
    if ((index !== this.breadcrumbsArray.length - 1)
      || BreadcrumbExceptionMapping.indexOf(item.id) > -1) {
      if (item['id']) {
        this.navService.navigateByMenuId(item['id']);
      } else if (item['route']) {
        this.index= index;
        this.navService.navigateByUrl(item['route']);
      }
    }
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/layout/home/breadcrumb/breadcrumb.component.ts